import { render } from "./FoodMenuPage.vue?vue&type=template&id=52b3acac"
import script from "./FoodMenuPage.vue?vue&type=script&lang=js"
export * from "./FoodMenuPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__